import { CalendarEvent, CalendarView } from 'angular-calendar';
import { endOfWeek, startOfWeek } from 'date-fns';

import { User } from '../../../user/user.model';
import { ScheduleItem } from '../models/schedule.model';

export interface RootState {
    pending: {
        init?: boolean;
        reload?: boolean;
    };
    view?: CalendarView;
    viewDate?: Date;
    startDate?: Date;
    endDate?: Date;
    events?: ScheduleItem[];
    calendarEvents?: Array<CalendarEvent<ScheduleItem>>;
    manager?: User;
    eventId: number;
}

export const defaultState = (): RootState => ({
    pending: {},
    view: CalendarView.Week,
    startDate: startOfWeek(new Date()),
    endDate: endOfWeek(new Date()),
    events: [],
    calendarEvents: [],
    eventId: 0,
});
